module.exports = {
    fi: {
        // keep alphabetical order by name
        drivingSchoolLocations : [
            {
                name: "Hämeenlinna",
                locations: [
                    {name:"Ajovarma Hämeenlinna"}
                ],
                languageTags: ["en","pt"]
            },
            {
                name: "Helsinki",
                locations: [
                    {name:"Ajovarma Helsinki-Herttoniemi"},
                    {name:"Ajovarma Helsinki-Malmi"},
                    {name: "Ajovarma Vantaa-Kaivoksela"},
                    {name: "Ajovarma Vantaa-Martinlaakso"},
                    {name: "Ajovarma Espoo-Hannuksenpelto"},
                    {name: "Ajovarma Espoo-Mankkaa"}
                ],
                languageTags: ["prs", "en", "es", "it", "zh", "chm", "fas", "pt", "fr", "sv", "sw", "ru"]
            },
            {
                name: "Joensuu",
                locations: [
                    {name:"Ajovarma Joensuu"}
                ],
                languageTags: ["ru"]
            },
            {
                name: "Jyväskylä",
                locations: [
                    {name:"Ajovarma Jyväskylä"}
                ],
                languageTags: ["ru"]
            },
            {
                name: "Kokkola",
                locations: [
                    {name:"Ajovarma Kokkola"}
                ],
                languageTags: ["th"]
            },
            {
                name: "Kotka",
                locations: [
                    {name:"Ajovarma Kotka"}
                ],
                languageTags: ["ru", "et"]
            },
            {
                name: "Kuopio",
                locations: [
                    {name:"Ajovarma Kuopio"}
                ],
                languageTags: ["prs", "fas"]
            },
            {
                name: "Lappeenranta",
                locations: [
                    {name:"Ajovarma Lappeenranta"}
                ],
                languageTags: ["zh", "ru"]
            },
            {
                name: "Pori",
                locations: [
                    {name:"Ajovarma Pori"}
                ],
                languageTags: ["et"]
            },
            {
                name: "Savonlinna",
                locations: [
                    {name:"Ajovarma Savonlinna"}
                ],
                languageTags: ["th"]
            },
            {
                name: "Tampere",
                locations: [
                    {name:"Ajovarma Tampere-Hervanta"},
                    {name:"Ajovarma Tampere-Lielahti"},
                    {name:"Ajovarma Nokia"}
                ],
                languageTags: ["ar", "ar_iq", "ar_sy", "yue", "zh", "kmrs", "kmr", "tr", "ru"]
            },
            {
                name: "Turku",                
                locations: [
                    {name:"Ajovarma Turku-Uhrilähteenkatu"}
                ],
                languageTags: ["prs", "en", "es", "it", "hac", "ckb", "fas", "pt", "sv", "ru" ]
            },
        ],       

    },

};